<nb-card class="employee-edit card-scroll" >
	<nb-card-header class="header">
		<div
			class="header-container"
			*ngIf="
				selectedDate &&
					selectedEmployeeFromHeader &&
					selectedEmployeeFromHeader.id;
				else noName
			"
		>
			<div style="display: flex">
				<ngx-back-navigation></ngx-back-navigation>
				<div class="employee-info">
					<img
						class="employee-image"
						[src]="selectedEmployee?.user?.imageUrl"
						alt="Employee Avatar"
					/>

					<div class="employee-details flex-row align-items-center">
						<nb-icon
							*ngIf="selectedEmployee?.isVerified"
							class="icon-verified"
							icon="checkmark-circle-2"
							status="primary"
						>
						</nb-icon>
						<span class="employee-name">{{ selectedEmployee?.user?.name }}</span
						>
						<div class="employee-position">
							{{ selectedEmployee?.organizationPosition?.name }}
						</div>
					</div>
				</div>
			</div>
			<div class="employee-info">
				<div class="employee-details">
					<div
						*ngIf="selectedEmployee?.user.username"
						class="transparent"
					>
						{{ 'FORM.USERNAME' | translate }}:
						<strong>{{ selectedEmployee?.user?.username }}</strong>
					</div>
					<div class="transparent">
						{{ 'FORM.EMAIL' | translate }}:
						<strong>{{ selectedEmployee?.user?.email }}</strong>
					</div>
				</div>
			</div>
		</div>
		<ng-template #noName>
			<h6>{{ 'EMPLOYEES_PAGE.SELECT_EMPLOYEE_MSG' | translate }}</h6>
		</ng-template>
	</nb-card-header>
	<nb-card-body
		><ngx-edit-employee-profile></ngx-edit-employee-profile>
	</nb-card-body>
</nb-card>
